import React from 'react';
import Navigation from '../Shared/Header/Navigation';

const About = () => {
    return (
        <div>
            <Navigation></Navigation>
            <h1>About</h1>
            <h1>About</h1>
            <h1>About</h1>

        </div>
    );
};

export default About;